import { render, staticRenderFns } from "./RegistrationEmailForm.vue?vue&type=template&id=07559984&"
import script from "./RegistrationEmailForm.vue?vue&type=script&lang=ts&"
export * from "./RegistrationEmailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports